/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

const DE = {
  LOADING: 'Lädt ...',
  SAVING: 'Speichern ...',
  SAVE_COMPLETE: 'Speichern abgeschlossen',
  ZOOM_IN_ERROR: 'Zoom zu hoch.',
  ZOOM_ERROR: 'Es kann nicht weiter vergrößert bzw. verkleinert werden.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: 'Thema konnte nicht angelegt werden. Bitte wählen Sie nur ein Thema aus.',
  ONE_TOPIC_MUST_BE_SELECTED: 'Thema konnte nicht angelegt werden. Es muss ein Thema ausgewählt werden.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: 'Kinderknoten können nicht eingefaltet werden. Es muss ein Thema ausgewählt werden.',
  SAVE_COULD_NOT_BE_COMPLETED: 'Sichern wurde nicht abgeschlossen. Versuchen Sie es später noch einmal.',
  UNEXPECTED_ERROR_LOADING: 'Es tut uns Leid, ein unerwarteter Fehler ist aufgetreten.\nVersuchen Sie, den Editor neu zu laden. Falls das Problem erneut auftritt, bitte kontaktieren Sie uns unter support@wisemapping.com.',
  MAIN_TOPIC: 'Hauptthema',
  SUB_TOPIC: 'Unterthema',
  ISOLATED_TOPIC: 'Isoliertes Thema',
  CENTRAL_TOPIC: 'Zentrales Thema',
  CLIPBOARD_IS_EMPTY: 'Es gibt nichts zu kopieren. Die Zwischenablage ist leer.',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: 'Das zentrale Thema kann nicht gelöscht werden.',
  RELATIONSHIP_COULD_NOT_BE_CREATED: 'Die Beziehung konnte nicht angelegt werden. Es muss erst ein Vater-Thema ausgewählt werden, um die Beziehung herzustellen.',
  SESSION_EXPIRED: 'Deine Sitzung ist abgelaufen, bitte melde dich erneut an.',
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: 'Der Verbindungsstil kann für das zentrale Thema nicht geändert werden.',
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: 'Der Sstil kann für das zentrale Thema nicht geändert werden.',
  TAB_TO_CREATE_CHILD: 'um Kind zu erstellen',
  ENTER_TO_CREATE_SIBLING: 'um Geschwister zu erstellen',
  PLUS_TOOLTIP_CREATE_CHILD: 'Kind-Thema erstellen',
  PLUS_TOOLTIP_CREATE_SIBLING: 'Geschwister-Thema erstellen',
};

export default DE;
